import Vue from 'vue'
import Keycloak from 'keycloak-js'

const options = {
  url: `${process.env.VUE_APP_KEYCLOAK_URL}`,
  clientId: `${process.env.VUE_APP_KEYCLOAK_CLIENT}`,
  realm: `${process.env.VUE_APP_KEYCLOAK_REALM}`,
  logoutRedirectUri: `${process.env.VUE_APP_KEYCLOAK_LOGOUT_REDIRECT_URI}`
}

const _keycloak = new Keycloak(options)

const Plugin = {
  install(Vue) {
    Vue.$keycloak = _keycloak
  }
}

Plugin.install = Vue => {
  Vue.$keycloak = _keycloak
  Object.defineProperties(Vue.prototype, {
    $keycloak: {
      get() {
        return _keycloak
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin